import Person from "@/types/Person.interface"

interface State {
    printQueue: Person[]
}

const defaults = () => {
    return {
        printQueue: []
    }
}

export default {
    state: defaults(),
    mutations: {
        printQueueAdd (state: State, person: Person): void {
            //  Add this person to our print queue
            state.printQueue.push(person)

            //  Store our print queue in local storage for future ref
            localStorage.setItem('printQueue', JSON.stringify(state.printQueue))
        },
        printQueueClear (state: State): void {
            //  Initialize our print queue to an empty array
            state.printQueue = []

            //  Remove the print queue from our local storage to clear all refs
            localStorage.removeItem('printQueue')
        },
        printQueueLoad (state: State): void {
            state.printQueue = JSON.parse(localStorage.getItem('printQueue'))
        },
        printQueueRemove (state: State, person: Person): void {
            //  Find the index of the person we want to remove
            const idx = state.printQueue.findIndex(x => x.id === person.id)

            //  If the index was not found, do nothing
            if (idx === -1) return

            //  Else, remove that person from our queue
            state.printQueue.splice(idx, 1)
        },
        printQueueReset (state: State) {
            Object.assign(state, defaults())
        }
    },
    actions: {},
    getters: {
        printQueue (state: State): Person[] {
            return state.printQueue
        }
    }
}